import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { styled, useThemeProps } from '../../foundation';
import { DividerStyle } from './styles';
var _RcDivider = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcDivider' });
    var vertical = props.vertical, size = props.size, color = props.color, title = props.title, titleBgColor = props.titleBgColor, _a = props.component, ComponentProp = _a === void 0 ? 'hr' : _a, rest = __rest(props, ["vertical", "size", "color", "title", "titleBgColor", "component"]);
    return React.createElement(ComponentProp, __assign({ ref: ref, role: "separator" }, rest));
});
var RcDivider = styled(_RcDivider)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), DividerStyle);
RcDivider.displayName = 'RcDivider';
RcDivider.defaultProps = {
    color: 'neutral.l02',
    titleBgColor: 'neutral.b01',
    size: 'default',
};
export { RcDivider };
var templateObject_1;
